<script lang="ts" setup>
import type {
  PlayerDetailsEmits,
  PlayerDetailsProps,
} from '@modules/players/submodules/PlayerProfile/types';
import PlayersTrackingForm
  from '@modules/players/submodules/PlayerProfile/components/PlayersTrackingForm/PlayersTrackingForm.vue';
import {
  TRANSLATION_GROUP_PLAYER_TRACKER,
} from '@modules/players/submodules/PlayerProfile/submodules/PlayerTracker/constants';

const props = defineProps<PlayerDetailsProps>();
const emits = defineEmits<PlayerDetailsEmits>();
</script>

<template>
  <PlayersTrackingForm v-data-qa-auto-id="'PlayerTrackerPage'"
    :is-loading="isLoading"
    :submit-btn-label="$getTranslation(TRANSLATION_GROUP_PLAYER_TRACKER, 'PLAYER_DETAILS_SAVE')"
    :errors="errors"
    :serial-id-label="$getTranslation(TRANSLATION_GROUP_PLAYER_TRACKER, 'SERIAL_ID')"
    :serial-id-value="props.playerData?.serial_id"
    :an-id-label="$getTranslation(TRANSLATION_GROUP_PLAYER_TRACKER, 'ANID')"
    :an-id-value="props.playerData?.anid"
    :date-label="$getTranslation(TRANSLATION_GROUP_PLAYER_TRACKER, 'DATE')"
    @submit="emits('submit', $event)"
    @interacted="emits('interacted', $event)"
  />
</template>
